const CsvHeaderIgnoreList: string[] = [
  'Custom label',
  'Sold via Promoted listings',
  'Payment method',
  'Minimum estimated delivery date',
  'Maximum estimated delivery date',
  'Dispatched on date',
  'Feedback left',
  'Feedback received',
  'My item note',
  'Tracking number',
  'Variation details',
  'eBay Plus'
];

export { CsvHeaderIgnoreList };
